<template>
  <d-container fluid class="main-content-container px-4">
    <d-row>
      <d-col lg="8" class="mx-auto mt-4">
        <d-card class="card-small edit-user-details mb-4">
          <d-card-body class="p-0" v-if="loadingPartner">
            <loader :is-loading="loadingPartner"></loader>
          </d-card-body>

          <d-card-body class="p-0" v-else>
            <d-form class="py-0">
              <d-form-row class="mx-4">
                <ValidationObserver
                  tag="form"
                  class="container-fluid h-100"
                  ref="PartnerValidationForm"
                >
                  <d-col
                    lg="12"
                    class="text-right"
                    style="margin-top: 4%; margin-bottom: -5%"
                  >
                    <div class="edit-user-details__avatar m-auto">
                      <img
                        alt="Avatar do Parceiro"
                        :key="hasChangedImage"
                        :src="Partner.PictureUrl"
                        id="imgPartner"
                      />
                      <label class="edit-user-details__avatar__change">
                        <i class="material-icons mr-1">&#xE439;</i>
                        <b-form-file
                          accept="image/*"
                          type="file"
                          @change="ChangeProfileImage($event)"
                          id="partnerProfilePicture"
                          class="d-none"
                        />
                      </label>
                    </div>
                    <legend id="legendChangeImg">
                      Clique na imagem para alterar a foto
                    </legend>
                  </d-col>
                  <h5 class="card-title mt-5">Identificação</h5>
                  <hr />

                  <d-form-row>
                    <!-- Merchant Type -->
                    <d-col md="3" class="form-group">
                      <label for="parMerchantType">Perfil da conta</label>
                      <d-select
                        disabled
                        :value="Partner.MerchantType.Code"
                        id="parMerchantType"
                      >
                        <option :value="'1'">Pessoa Física</option>
                        <option :value="'2'">Pessoa Jurídica</option>
                      </d-select>
                    </d-col>

                    <!-- First Name -->
                    <d-col md="3" class="form-group">
                      <label for="parName">{{
                        Partner.MerchantType.Code == 1 ? "Nome" : "Razão social"
                      }}</label>
                      <d-form-input
                        v-if="Partner.MerchantType.Code == 1"
                        readonly
                        :value="Partner.Name"
                        @input="Update('ResponsibleName', $event)"
                        type="text"
                        id="parName"
                        placeholder="Nome"
                      />
                      <d-form-input
                        v-else
                        readonly
                        :value="Partner.Name"
                        type="text"
                        id="parName"
                        placeholder="Nome"
                      />
                    </d-col>

                    <!-- Identity -->
                    <d-col md="3" class="form-group">
                      <label for="parIdentity">{{
                        Partner.MerchantType.Code == 1 ? "CPF" : "CNPJ"
                      }}</label>
                      <the-mask
                        v-if="Partner.MerchantType.Code == 1"
                        id="parIdentityCPF"
                        readonly
                        class="form-control"
                        type="tel"
                        :mask="['###.###.###-##']"
                        :value="Partner.Identity"
                        @input="Update('ResponsibleIdentity', $event)"
                        placeholder="CPF"
                      />
                      <the-mask
                        v-else
                        id="parIdentity"
                        readonly
                        class="form-control"
                        type="tel"
                        :mask="['##.###.###/####-##']"
                        :value="Partner.Identity"
                        placeholder="CNPJ"
                      />
                    </d-col>

                    <!-- CommercialName -->
                    <d-col md="3" class="form-group">
                      <label for="commercialName">{{
                        Partner.MerchantType.Code == 1
                          ? "Nome comercial"
                          : "Nome fantasia"
                      }}</label>
                      <d-form-input
                        v-model="Partner.CommercialName"
                        :disabled="loading"
                        type="text"
                        id="commercialName"
                        placeholder="Nome fantasia"
                      />
                    </d-col>
                  </d-form-row>
                  <d-form-row>
                    <!-- ContactName -->
                    <d-col
                      :md="Partner.MerchantType.Code == 1 ? '4' : '6'"
                      class="form-group"
                    >
                      <label>Nome do contato</label>
                      <d-form-input readonly :value="Partner.ContactName" />
                    </d-col>
                    <!-- Email -->
                    <d-col
                      v-if="Partner.MerchantType.Code == 1"
                      md="4"
                      class="form-group"
                    >
                      <label for="parEmail">Email</label>
                      <d-form-input
                        readonly
                        :value="Partner.Email"
                        type="email"
                        id="parEmail"
                        placeholder="Email"
                      />
                    </d-col>
                    <!-- Phone -->
                    <d-col
                      :md="Partner.MerchantType.Code == 1 ? '4' : '6'"
                      class="form-group"
                    >
                      <label for="parPhone">Telefone</label>
                      <ValidationProvider
                        rules="required|min:10"
                        v-slot="{ errors, invalid }"
                      >
                        <d-input-group seamless>
                          <d-input-group-text slot="prepend">
                            <i class="fas fa-phone-alt"></i>
                          </d-input-group-text>
                          <the-mask
                            v-if="Partner.MerchantType.Code == 1"
                            id="parPhone"
                            class="form-control"
                            :class="
                              validatedPartnerForm | showValidateError(invalid)
                            "
                            :disabled="loading"
                            type="tel"
                            :mask="['(##) #####-####', '(##) ####-####']"
                            v-model="Partner.Phone"
                            @input="Update('ResponsiblePhone', $event)"
                            placeholder="Telefone"
                          />
                          <the-mask
                            v-else
                            id="parPhone"
                            class="form-control"
                            :class="
                              validatedPartnerForm | showValidateError(invalid)
                            "
                            :disabled="loading"
                            type="tel"
                            :mask="['(##) #####-####', '(##) ####-####']"
                            v-model="Partner.Phone"
                            placeholder="Telefone"
                          />
                        </d-input-group>
                        <div
                          class="invalid-feedback d-block"
                          v-if="validatedPartnerForm"
                        >
                          {{ errors[0] }}
                        </div>
                      </ValidationProvider>
                    </d-col>
                  </d-form-row>

                  <div v-if="Partner.MerchantType.Code != 1">
                    <h5 class="card-title">Responsável</h5>
                    <hr />
                    <d-form-row>
                      <!-- ResponsibleName -->
                      <d-col md="6" class="form-group">
                        <label>Nome</label>
                        <ValidationProvider
                          rules="required:true|min:3"
                          v-slot="{ errors, invalid }"
                        >
                          <d-form-input
                            :class="
                              validatedPartnerForm | showValidateError(invalid)
                            "
                            type="text"
                            v-model="Partner.ResponsibleName"
                            :disabled="
                              loading ||
                              (Partner.ResponsibleName != null &&
                                Partner.ResponsibleName != undefined &&
                                Partner.ResponsibleName.length > 0)
                            "
                          />
                          <div
                            class="invalid-feedback d-block"
                            v-if="validatedPartnerForm"
                          >
                            {{ errors[0] }}
                          </div>
                        </ValidationProvider>
                      </d-col>
                      <!-- ResponsibleIdentity -->
                      <d-col md="6" class="form-group float-right">
                        <label>CPF</label>
                        <ValidationProvider
                          rules="required|min:11|identity"
                          v-slot="{ errors, invalid }"
                        >
                          <the-mask
                            class="form-control"
                            :class="
                              validatedPartnerForm | showValidateError(invalid)
                            "
                            type="text"
                            :mask="['###.###.###-##']"
                            v-model="Partner.ResponsibleIdentity"
                            :disabled="
                              loading ||
                              (Partner.ResponsibleIdentity != null &&
                                Partner.ResponsibleIdentity != undefined &&
                                Partner.ResponsibleIdentity.length > 0)
                            "
                          />
                          <div
                            class="invalid-feedback d-block"
                            v-if="validatedPartnerForm"
                          >
                            {{ errors[0] }}
                          </div>
                        </ValidationProvider>
                      </d-col>
                    </d-form-row>
                    <d-form-row>
                      <!-- Email -->
                      <d-col md="6" class="form-group">
                        <label>E-mail</label>
                        <d-form-input
                          readonly
                          type="email"
                          v-model="Partner.Email"
                        />
                      </d-col>
                      <!-- ResponsiblePhone -->
                      <d-col md="6" class="form-group">
                        <label for="parPhone">Telefone</label>
                        <ValidationProvider
                          rules="required|min:10"
                          v-slot="{ errors, invalid }"
                        >
                          <d-input-group seamless>
                            <d-input-group-text slot="prepend">
                              <i class="fas fa-phone-alt"></i>
                            </d-input-group-text>
                            <the-mask
                              id="parPhone"
                              class="form-control"
                              type="tel"
                              :class="
                                validatedPartnerForm
                                  | showValidateError(invalid)
                              "
                              :mask="['(##) #####-####', '(##) ####-####']"
                              v-model="Partner.ResponsiblePhone"
                              :disabled="loading"
                            />
                          </d-input-group>
                          <div
                            class="invalid-feedback d-block"
                            v-if="validatedPartnerForm"
                          >
                            {{ errors[0] }}
                          </div>
                        </ValidationProvider>
                      </d-col>
                    </d-form-row>
                  </div>

                  <h5 class="card-title">Endereço</h5>
                  <hr />

                  <d-form-row>
                    <!-- Zip Code -->
                    <d-col md="3" class="form-group">
                      <label for="inputZip">CEP</label>
                      <ValidationProvider
                        rules="required|min:8"
                        v-slot="{ errors, invalid }"
                      >
                        <the-mask
                          id="inputZip"
                          class="form-control"
                          :class="
                            validatedPartnerForm | showValidateError(invalid)
                          "
                          :disabled="loading"
                          type="tel"
                          :mask="['#####-###']"
                          @change.native="GetAddressByCep()"
                          v-model="Partner.Address.ZipCode"
                        />
                        <div
                          class="invalid-feedback d-block"
                          v-if="validatedPartnerForm"
                        >
                          {{ errors[0] }}
                        </div>
                      </ValidationProvider>
                    </d-col>

                    <!-- Street -->
                    <d-col md="7" class="form-group">
                      <label for="parInputStreet">Logradouro</label>
                      <ValidationProvider
                        rules="required|min:3"
                        v-slot="{ errors, invalid }"
                      >
                        <d-form-input
                          v-model="Partner.Address.Street"
                          :class="
                            validatedPartnerForm | showValidateError(invalid)
                          "
                          :disabled="loading"
                          type="text"
                          id="parInputStreet"
                          placeholder="Logradouro"
                        />
                        <div
                          class="invalid-feedback d-block"
                          v-if="validatedPartnerForm"
                        >
                          {{ errors[0] }}
                        </div>
                      </ValidationProvider>
                    </d-col>

                    <!-- Number -->
                    <d-col md="2" class="form-group">
                      <label for="parInputNumber">Número</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors, invalid }"
                      >
                        <the-mask
                          id="parInputNumber"
                          class="form-control"
                          :class="
                            validatedPartnerForm | showValidateError(invalid)
                          "
                          :disabled="loading"
                          type="tel"
                          :mask="['##########']"
                          v-model="Partner.Address.Number"
                          placeholder="Número"
                        />
                        <div
                          class="invalid-feedback d-block"
                          v-if="validatedPartnerForm"
                        >
                          {{ errors[0] }}
                        </div>
                      </ValidationProvider>
                    </d-col>
                  </d-form-row>

                  <d-form-row>
                    <!-- Complement -->
                    <d-col md="4" class="form-group">
                      <label for="parInputComplement">Complemento</label>
                      <d-form-input
                        v-model="Partner.Address.Complement"
                        :disabled="loading"
                        type="text"
                        id="parInputComplement"
                        placeholder="Complemento"
                      />
                    </d-col>

                    <!-- District -->
                    <d-col md="4" class="form-group">
                      <label for="parInputDistrict">Bairro</label>
                      <ValidationProvider
                        rules="required|min:2"
                        v-slot="{ errors, invalid }"
                      >
                        <d-form-input
                          v-model="Partner.Address.District"
                          :class="
                            validatedPartnerForm | showValidateError(invalid)
                          "
                          :disabled="loading"
                          type="text"
                          id="parInputDistrict"
                          placeholder="Bairro"
                        />
                        <div
                          class="invalid-feedback d-block"
                          v-if="validatedPartnerForm"
                        >
                          {{ errors[0] }}
                        </div>
                      </ValidationProvider>
                    </d-col>

                    <!-- Country -->
                    <d-col md="4" class="form-group">
                      <label for="parInputCountry">País</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors, invalid }"
                      >
                        <d-select
                          v-model="Partner.Address.Country.Name"
                          :class="
                            validatedPartnerForm | showValidateError(invalid)
                          "
                          :disabled="loading"
                          :value="null"
                          id="parInputCountry"
                        >
                          <option :value="null" selected>Selecione</option>
                          <option
                            v-for="country in Countries"
                            v-bind:value="country.Name"
                            v-bind:key="country.Id"
                          >
                            {{ country.Name }}
                          </option>
                        </d-select>
                        <div
                          class="invalid-feedback d-block"
                          v-if="validatedPartnerForm"
                        >
                          {{ errors[0] }}
                        </div>
                      </ValidationProvider>
                    </d-col>
                  </d-form-row>

                  <d-form-row>
                    <!-- State -->
                    <d-col md="6" class="form-group">
                      <label for="parInputState">Estado</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors, invalid }"
                      >
                        <d-select
                          v-model="Partner.Address.State.Initials"
                          :class="
                            validatedPartnerForm | showValidateError(invalid)
                          "
                          :disabled="loading"
                          :value="null"
                          id="parInputState"
                        >
                          <option :value="null" selected>Selecione</option>
                          <option
                            v-for="state in states"
                            v-bind:key="state.Initials"
                            v-bind:value="state.Initials"
                          >
                            {{ state.Name }}
                          </option>
                        </d-select>
                        <div
                          class="invalid-feedback d-block"
                          v-if="validatedPartnerForm"
                        >
                          {{ errors[0] }}
                        </div>
                      </ValidationProvider>
                    </d-col>

                    <!-- City -->
                    <d-col md="6" class="form-group">
                      <label for="parInputCity">Cidade</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors, invalid }"
                      >
                        <d-select
                          v-model="Partner.Address.City.CodeIBGE"
                          :class="
                            validatedPartnerForm | showValidateError(invalid)
                          "
                          :disabled="loading"
                          :value="null"
                          id="parInputCity"
                        >
                          <option
                            :value="null"
                            v-if="Partner.Address.State.Initials == null"
                            selected
                          >
                            Primeiro selecione o Estado
                          </option>
                          <option :value="null" v-else selected>
                            Selecione
                          </option>
                          <option
                            v-for="(city, i) in cities"
                            :key="i"
                            :value="city.CodeIBGE"
                          >
                            {{ city.Name }}
                          </option>
                        </d-select>
                        <div
                          class="invalid-feedback d-block"
                          v-if="validatedPartnerForm"
                        >
                          {{ errors[0] }}
                        </div>
                      </ValidationProvider>
                    </d-col>
                  </d-form-row>
                </ValidationObserver>
              </d-form-row>
            </d-form>
          </d-card-body>

          <!-- Save Changes -->
          <d-card-footer class="border-top">
            <div class="float-right">
              <b-button
                size="sm"
                v-on:click.stop="UndoChanges($event)"
                :disabled="loading || !hasChanges"
                class="mr-2 btn-accent"
              >
                <i class="fas fa-undo-alt"></i>
              </b-button>
              <b-button
                size="sm"
                v-on:click.stop="ProcessChanges()"
                :disabled="loading || loadingPartner"
                class="mr-2 btn-accent"
              >
                <template v-if="!loading">Salvar</template>
                <template v-else>
                  <loader :small="true" :isLoading="loading"></loader>
                </template>
              </b-button>
            </div>
          </d-card-footer>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { FileToBase64 } from "../../utils/fileUtils.js";

export default {
  name: "partner-data",
  components: {},
  beforeMount() {
    this.GetPartner();
  },
  mounted() {
    this.GetCountries();
  },
  computed: {
    Country() {
      return this.Partner.Address.Country.Id;
    },
    HasChanges() {
      return this.PartnerData != this.OriginalPartnerData;
    },
    PartnerModel() {
      return this.Partner;
    },
    State() {
      return this.Partner.Address.State.Initials;
    },
  },
  data() {
    return {
      changing: false,
      cities: [],
      hasChangedImage: 0,
      isSearchZipCode: false,
      hasChanges: false,
      loading: false,
      loadingPartner: false,
      OriginalPartner: null,
      Partner: {
        Name: "",
        Identity: "",
        Email: "",
        Phone: "",
        CommercialName: "",
        MerchantType: {
          Code: null,
        },
        Address: {
          Street: "",
          District: null,
          Number: "",
          ZipCode: "",
          Complement: "",
          City: {
            Name: null,
            CodeIBGE: null
          },
          State: {
            Initials: null
          },
          Country: {
            Name: null
          },
        },
      },
      states: [],
      validatedPartnerForm: false,
      Countries: [],
    };
  },
  methods: {
    ChangeProfileImage(event) {
      const file = event.target.files[0];

      if (file != null) {
        if (file.size / 1024 > 1024) {
          this.$makeToast(
            "O tamanho máximo permitido para imagem é 1 MegaByte!",
            "danger",
            "Tamanho maximo excedido!"
          );
          return;
        }
        FileToBase64(file)
          .then((image) => {
            if (image.startsWith("data:image")) {
              this.Partner.PictureUrl = image;
              this.hasChangedImage += 1;
              this.PictureFile = file;
            } else {
              this.$makeToast(
                "O arquivo selecionado não é uma imagem válida!",
                "danger",
                "Falha ao abrir imagem"
              );
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    GetCountries() {
      this.$store.dispatch("GetCountries").then((response) => {
        this.Countries = response;
      });
    },
    GetAddressByCep: function () {
      let zipCodeNumber = this.Partner.Address.ZipCode.replace(/\D+/gm, "");

      if (zipCodeNumber.length != 8) {
        this.$makeToast(
          "Verifique o número e tente novamente.",
          "warning",
          `O CEP digitado não é válido: "${zipCodeNumber}"`
        );
        return;
      }

      this.$store
        .dispatch("GetAddressByCep", {
          zipCode: zipCodeNumber,
        })
        .then((response) => {
          if (!response.erro) {
            this.isSearchZipCode = true;

            this.Partner.Address.Country.Id = 24;
            this.Partner.Address.State.Initials = response.uf;

            this.Partner.Address.Street = response.logradouro;
            this.Partner.Address.District = response.bairro;

            this.Partner.Address.City.CodeIBGE = response.ibge;
          } else {
            this.$makeToast(
              "Verifique o número digitado e tente novamente.",
              "warning",
              "CEP não encontrado"
            );
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Não foi possível buscar o endereço.",
            "danger",
            "Busca de endereço",
            error
          );
        });
    },
    GetPartner() {
      this.loadingPartner = true;
      this.$store
        .dispatch("GetPartner")
        .then((response) => {
          this.hasChanges = false;
          this.Partner = response;
          this.OriginalPartner = JSON.parse(JSON.stringify(response));

          if (!this.Partner.PictureUrl)
            this.Partner.PictureUrl = require("@/assets/images/avatars/user2.png");
          else
            this.Partner.PictureUrl =
              this.Partner.PictureUrl + `?${Math.random()}`;
        })
        .catch((error) => {
          this.$makeToast(
            "Falha ao obter informações do parceiro, tente novamente",
            "danger",
            "Erro ao carregar Parceiro",
            error
          );
        })
        .finally(() => {
          this.loadingPartner = false;
        });
    },
    ListStates: function (countryId) {
      let self = this;

      this.$store
        .dispatch("GetStates", {
          idCountry: countryId,
        })
        .then((response) => {
          self.states = response;
        })
        .catch((error) => {
          this.$makeToast(
            "Não foi possível buscar os estados.",
            "danger",
            "Listagem de estados",
            error
          );
        });
    },
    AppendFormdata(obj, form, namespace) {
      var fd = form || new FormData();
      var formKey;

      for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
          if (namespace) {
            formKey = namespace + "[" + property + "]";
          } else {
            formKey = property;
          }

          // if the property is an object, but not a File,
          // use recursivity.
          if (typeof obj[property] === "object") {
            this.AppendFormdata(obj[property], fd, formKey);
          } else {
            fd.append(formKey, obj[property]);
          }
        }
      }

      return fd;
    },
    GetFormData(object) {
      // var postData = JSON.stringify(object);

      return this.AppendFormdata(object);
    },
    ProcessChanges: function () {
      this.validatedPartnerForm = true;
      this.$refs.PartnerValidationForm.validate().then((isValid) => {
        if (isValid) {
          this.validatedPartnerForm = false;

          if (!this.hasChanges) {
            this.$makeToast(
              "Para continuar altere ao menos uma informação.",
              "info",
              "Nenhuma alteração detectada"
            );
            return;
          }

          let PartnerNow = JSON.parse(JSON.stringify(this.Partner));
          delete PartnerNow.PictureUrl;

          var formData = this.GetFormData(PartnerNow);

          if (this.hasChangedImage) {
            formData.append("Image", this.PictureFile, this.PictureFile.name);
          }

          this.loading = true;
          this.$store
            .dispatch("UpdatePartner", formData)

            .then((response) => {
              this.hasChanges = false;
              this.changing = true;

              if (response.PictureUrl == null) {
                response.PictureUrl = this.Partner.PictureUrl;
              }

              this.Partner = response;
              this.OriginalPartner = JSON.parse(JSON.stringify(response));

              this.$makeToast(
                "Os dados cadastrais do parceiro foram atualizados corretamente.",
                "success",
                "Informações atualizadas com sucesso!"
              );

              setTimeout(() => {
                this.changing = false;
              }, 200);
            })
            .catch((error) => {
              this.$makeToast(
                "Não foi possível atualizar os dados, tente novamente.",
                "danger",
                "Falha ao atualizar dados cadastrais",
                error
              );
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    UndoChanges(event) {
      event.preventDefault();
      this.hasChanges = false;
      this.changing = true;

      this.Partner = JSON.parse(JSON.stringify(this.OriginalPartner));

      setTimeout(() => {
        this.changing = false;
      }, 200);
    },
    Update: function (key, value) {
      if (key != null) this.Partner[key] = value;
    },
  },
  watch: {
    Country(selected, old) {
      // Update State list when the Country is changed.
      if (selected != null) {
        this.ListStates(selected);
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.Partner.Address.State.Initials = null;
        }
      } else {
        this.states = [];
        this.Partner.Address.State.Initials = null;
      }
      this.isSearchZipCode = false;
    },
    Partner: {
      handler() {
        if (!this.loadingPartner) {
          if (!this.changing) {
            this.hasChanges = true;
          }
        }
      },
      deep: true,
    },
    State(selected, old) {
      // Update City list when the State (of Country) is changed.
      if (selected != null) {
        this.$store
          .dispatch("GetCities", { stateInitials: selected })
          .then((response) => {
            this.cities = response;
          });
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.Partner.Address.City.CodeIBGE = null;
        }
      } else {
        this.cities = [];
        this.Partner.Address.City.CodeIBGE = null;
      }
      this.isSearchZipCode = false;
    },
  },
};
</script>

<style>
#imgPartner {
  height: 120px;
  width: 120px;
}
#legendChangeImg {
  margin-top: 5px;
  font-size: 0.7em;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/partnerData.vue